import { useEffect, useState } from 'react';
import { STATE } from '../../classes/Enum';
import 'hover-tilt/web-component';
import { getImageUrl } from '../../helper/image';
import DeferredImage from './DeferredImage';


const ProductImageComponent = ({ item }) => {

  const isACard = item.type === STATE.CARD;
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1000);

      useEffect(() => {
      const onResize = () => {
          setIsMobile(window.innerWidth < 1000);
      };

      window.addEventListener("resize", onResize);
      return () => window.removeEventListener("resize", onResize);
    }, []);

  const imageProps = {
    className: `product-img ${item.type === STATE.CARD && 'radius'}`,
    alt: item.name,
  };

  return (
    <hover-tilt class="radius hover-tilt" tilt-factor="1.5" glare-intensity={item.type !== "CARD" ? "0" : "1"}>
    <div
      className={`product-img-wrapper radius type-${item.pokemonType?.toLowerCase()}`}

    >
        <DeferredImage {...imageProps} src={getImageUrl(item)} />
      </div>
      </hover-tilt>
  );
};

export default ProductImageComponent;
